import { toast as sonnerToast } from "sonner"

type ToastVariant = "default" | "destructive"

interface ToastProps {
  title: string;
  description?: string;
  variant?: ToastVariant;
}

export const useToast = () => {
  const toast = ({ title, description, variant = "default" }: ToastProps) => {
    if (variant === "destructive") {
      sonnerToast.error(title, {
        description,
      })
    } else {
      sonnerToast(title, {
        description,
      })
    }
  }

  return { toast }
}
